<div class="center">
  <div>
    <div>
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
        animationDuration=".5s"></p-progressSpinner>
    </div>
    <div>
      {{ 'bikeshop.redirect.message' | translate }}
    </div>
  </div>
</div>